


// import React, { useState, useEffect, useMemo } from "react";
// import { Col, Container, Row, Tab, Tabs } from "react-bootstrap";
// import ProductCard from "./productCard";
// import { useDispatch, useSelector } from "react-redux";
// import { fetchProducts, selectProducts } from "../redux/productSlice"; // Adjust the path as needed
// import "../css/allProductList.css";
// import Slider from "react-slick";
// import '../css/sliderCustom.css';
// import Loader from './loadingSpinner'; // Optional: A loader component

// const ControlledTabs = () => {
//   const dispatch = useDispatch();
//   const products = useSelector(selectProducts);
//   const [key, setKey] = useState("latestProduct");

//   // useEffect(() => {
//   //   // Ensure fetchProducts is only called once
//   //   dispatch(fetchProducts());
//   // }, [dispatch]); // Only run on mount

//   // Memoize the derived product lists
//   const latestProducts = useMemo(() => products.slice(-6), [products]);
//   const topRatingProducts = useMemo(() => 
//     [...products].sort((a, b) => b.rating - a.rating).slice(0, 6), 
//     [products]
//   );
//   const bestSellingProducts = useMemo(() => 
//     [...products].sort((a, b) => b.reviews - a.reviews).slice(0, 6), 
//     [products]
//   );
//   const featureProducts = useMemo(() => 
//     products.filter(product => product.isUpcoming).slice(0, 6), 
//     [products]
//   );


//   // Slider settings
//   const settings = {
//     dots: true,
//     infinite: true,
//     speed: 500,
//     slidesToShow: 4,
//     slidesToScroll: 4,
//     responsive: [
//       {
//         breakpoint: 992,
//         settings: {
//           slidesToShow: 3,
//           slidesToScroll: 3,
//           infinite: true,
//           dots: true
//         }
//       },
//       {
//         breakpoint: 767,
//         settings: {
//           slidesToShow: 2,
//           slidesToScroll: 2
//         }
//       },
//       {
//         breakpoint: 376,
//         settings: {
//           slidesToShow: 1,
//           slidesToScroll: 1
//         }
//       }
//     ]
//   };

//   // Loading state (optional)
//   const [loading, setLoading] = useState(true);

//   useEffect(() => {
//     // Update loading state based on products length
//     if (products.length > 0) {
//       setLoading(false);
//     }
//   }, [products]); // Dependency on products

//   return (
//     <>
//       <br /><br />
//       <section className="title-weekdeal title-section mt-5">
//         <Container>
//           <Row>
//             <Col md={12}>
//               <div className="text-center d-flex align-items-center justify-content-center flex-column">
//                 <h2>TOP PRODUCTS</h2>
//               </div>
//             </Col>
//           </Row>
//         </Container>
//       </section>
//       <section className="mt-4 allProductList">
//         <Container className="mainProductCartRowAll">
//           <Row>
//             <Col md={12}>
//               <Tabs
//                 id="controlled-tab-example"
//                 activeKey={key}
//                 onSelect={(k) => setKey(k)}
//                 className="mb-3"
//               >
//                 <Tab eventKey="latestProduct" title="Latest Product">
//                   {loading ? (
//                     <Loader /> // Show loader while products are loading
//                   ) : (
//                     <div className="mt-4 allProductListproductCard">
//                       <Row>
//                         <Slider {...settings}>
//                           {latestProducts.map((product) => (
//                             <ProductCard key={product.id} product={product} />
//                           ))}
//                         </Slider>
//                       </Row>
//                     </div>
//                   )}
//                 </Tab>
//                 <Tab eventKey="topRating" title="Top Rating">
//                   {loading ? (
//                     <Loader />
//                   ) : (
//                     <div className="mt-4 allProductListproductCard">
//                       <Row>
//                         <Slider {...settings}>
//                           {topRatingProducts.map((product) => (
//                             <ProductCard key={product.id} product={product} />
//                           ))}
//                         </Slider>
//                       </Row>
//                     </div>
//                   )}
//                 </Tab>
//                 <Tab eventKey="bestSelling" title="Best Selling">
//                   {loading ? (
//                     <Loader />
//                   ) : (
//                     <div className="mt-4 allProductListproductCard">
//                       <Row>
//                         <Slider {...settings}>
//                           {bestSellingProducts.map((product) => (
//                             <ProductCard key={product.id} product={product} />
//                           ))}
//                         </Slider>
//                       </Row>
//                     </div>
//                   )}
//                 </Tab>
//                 <Tab eventKey="feature" title="Feature">
//                   {loading ? (
//                     <Loader />
//                   ) : (
//                     <div className="mt-4 allProductListproductCard">
//                       <Row>
//                         <Slider {...settings}>
//                           {featureProducts.map((product) => (
//                             <ProductCard key={product.id} product={product} />
//                           ))}
//                         </Slider>
//                       </Row>
//                     </div>
//                   )}
//                 </Tab>
//               </Tabs>
//             </Col>
//           </Row>
//         </Container>
//       </section>
//     </>
//   );
// };

// export default ControlledTabs;
import React, { useState, useEffect, useMemo } from "react";
import { Col, Container, Row, Tab, Tabs } from "react-bootstrap";
import ProductCard from "./productCard";
import { useDispatch, useSelector } from "react-redux";
import { fetchProducts, selectProducts } from "../redux/productSlice"; // Adjust the path as needed
import "../css/allProductList.css";
import Slider from "react-slick";
import '../css/sliderCustom.css';
import Loader from './loadingSpinner'; // Optional: A loader component
import useProductActions from '../utils/productThanos';
import LoadingSpinner from "./loadingSpinner";
const ControlledTabs = () => {
  const {    key,setKey, latestProducts,topRatingProducts, bestSellingProducts,featureProducts,  loading}=useProductActions()

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 4,
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: true,
          dots: true
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      },
      {
        breakpoint: 376,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  };

  return (
    <>
      <br /><br />
      <section className="title-weekdeal title-section mt-5">
        <Container>
          <Row>
            <Col md={12}>
              <div className="text-center d-flex align-items-center justify-content-center flex-column">
                <h2>TOP PRODUCTS</h2>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
      <section className="mt-4 allProductList">
        <Container className="mainProductCartRowAll">
          <Row>
            <Col md={12}>
              <Tabs
                id="controlled-tab-example"
                activeKey={key}
                onSelect={(k) => setKey(k)}
                className="mb-3"
              >
                <Tab eventKey="latestProduct" title="Latest Product">
                  {loading ? (
                    <LoadingSpinner /> // Show loader while products are loading
                  ) : (
                    <div className="mt-4 allProductListproductCard">
                      <Row>
                        <Slider {...settings}>
                          {latestProducts.map((product) => (
                            <ProductCard key={product.id} product={product} />
                          ))}
                        </Slider>
                      </Row>
                    </div>
                  )}
                </Tab>
                <Tab eventKey="topRating" title="Top Rating">
                  {loading ? (
                    <LoadingSpinner />
                  ) : (
                    <div className="mt-4 allProductListproductCard">
                      <Row>
                        <Slider {...settings}>
                          {topRatingProducts.map((product) => (
                            <ProductCard key={product.id} product={product} />
                          ))}
                        </Slider>
                      </Row>
                    </div>
                  )}
                </Tab>
                <Tab eventKey="bestSelling" title="Best Selling">
                  {loading ? (
                    <LoadingSpinner />
                  ) : (
                    <div className="mt-4 allProductListproductCard">
                      <Row>
                        <Slider {...settings}>
                          {bestSellingProducts.map((product) => (
                            <ProductCard key={product.id} product={product} />
                          ))}
                        </Slider>
                      </Row>
                    </div>
                  )}
                </Tab>
                <Tab eventKey="feature" title="Feature">
                  {loading ? (
                    <LoadingSpinner />
                  ) : (
                    <div className="mt-4 allProductListproductCard">
                      <Row>
                        <Slider {...settings}>
                          {featureProducts.map((product) => (
                            <ProductCard key={product.id} product={product} />
                          ))}
                        </Slider>
                      </Row>
                    </div>
                  )}
                </Tab>
              </Tabs>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};

export default ControlledTabs;